import HomeCtrl from "./HomeCtrl";
export default class RkCtrl extends HomeCtrl {

  constructor(AuthService, KontaktService, OdberneMiestoService, SamoodpocetService, $state, $stateParams){
    super(AuthService, KontaktService, OdberneMiestoService, SamoodpocetService, $state, $stateParams);
    this.samoodpocet = false;
  }
}


// WEBPACK FOOTER //
// ./src/Home/RkCtrl.js